export default "__VITE_ASSET__CGxyG3yd__"